import { render, staticRenderFns } from "./KohlerMilestone.vue?vue&type=template&id=2f40bf01&scoped=true&"
import script from "./KohlerMilestone.vue?vue&type=script&lang=js&"
export * from "./KohlerMilestone.vue?vue&type=script&lang=js&"
import style0 from "./KohlerMilestone.vue?vue&type=style&index=0&id=2f40bf01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40bf01",
  null
  
)

export default component.exports